/**
 * IDs de estados de tareas en la tabla Estados (tipo='ARQ').
 *
 * Estos IDs son la fuente de verdad — los nombres ('Hielera', 'En Proceso',
 * etc.) son descripciones que pueden cambiar sin afectar la lógica.
 *
 * Mantener en sync con backend/ArquiFlow.Api/Constants/EstadoIds.cs
 */
export const ESTADO_IDS = {
  HIELERA: 23,
  POR_TRABAJAR: 24,
  EN_PROCESO: 25,
  REVISION: 26,
  COMPLETADO: 27,
  PAUSA: 28,
  CORRECCIONES: 29,
} as const;

export type EstadoId = typeof ESTADO_IDS[keyof typeof ESTADO_IDS];
